import gql from 'graphql-tag';

import { useMetricQueries } from '../../lib/hooks';
import { createBatchedFetcher } from '../../lib/gqlFetcher_myf2b';

const fetcher = createBatchedFetcher(100);

const QUERY = gql`
	query metrics_curriculaWithProgress(
		$entityType: EntityType!,
		$entityId: ID!,
		$gradeIds: [ID!],
		$schoolIds: [ID!],
	) {
		metrics(entityId: $entityId, entityType: $entityType) {
			curriculaWithProgress(gradeIds: $gradeIds, schoolIds: $schoolIds)
		}
	}
`;

const useCurriculumIdsWithProgress = (entities) => useMetricQueries(
	entities.map(
		([entityType, entityId, { gradeIds, schoolIds } = {}]) => ({
			document: QUERY,
			variables: { entityType, entityId, gradeIds, schoolIds },
			options: {
				queryKey: ['metrics_curriculaWithProgress', entityType, entityId, gradeIds, schoolIds],
				transformer: ({ metrics: { curriculaWithProgress } }) => ({
					entityType,
					entityId,
					curriculaWithProgress,
				}),
			},
		})
	),
	fetcher,
);
export default useCurriculumIdsWithProgress;
